export const InspectionStepTitle = () => {
  return (
    <div className="InspectionStepTitle">
      Standard Inspection is available up to 40 Kms. Comprehensive and Premium price increases after 40 Kms from Melbourne CBD.
    </div>
  );
};
